import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Loader2 } from 'lucide-react';

const SUPER_ADMIN_EMAIL = ((import.meta.env.VITE_SUPER_ADMIN_EMAIL as string | undefined) ?? '').toLowerCase();

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

/**
 * SuperAdminRoute — restricts access exclusively to gowithankit@gmail.com.
 * Any other logged-in user is redirected to their dashboard.
 * Unauthenticated users are redirected to /auth.
 */
export function SuperAdminRoute({ children }: SuperAdminRouteProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-accent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth?returnUrl=/employer/agents" replace />;
  }

  if (user.email?.toLowerCase() !== SUPER_ADMIN_EMAIL) {
    return <Navigate to="/employer/dashboard" replace />;
  }

  return <>{children}</>;
}

export default SuperAdminRoute;
